import { useEffect, useEffectEvent } from "react"

import { useApplicationScope } from "../application/application-provider"
import type { MessageDefinition, MessageHandler, Messenger } from "./messenger"

export function useMessenger(): Messenger {
  return useApplicationScope().messenger
}

export function useMessage<TPayload>(message: MessageDefinition<TPayload>, handler: MessageHandler<TPayload>) {
  const messenger = useMessenger()
  const onMessage = useEffectEvent(handler)

  useEffect(() => messenger.on(message, onMessage), [messenger, message])
}
